import { createContext, useContext, type ReactNode } from "react";
import type { SettingsSection } from "./SettingsModal.js";

const SettingsLauncherContext = createContext<((section: SettingsSection) => void) | null>(null);

export function SettingsLauncherProvider({ open, children }: { open: (section: SettingsSection) => void; children: ReactNode }) {
  return <SettingsLauncherContext.Provider value={open}>{children}</SettingsLauncherContext.Provider>;
}

export function useSettingsLauncher() {
  const open = useContext(SettingsLauncherContext);
  if (!open) throw new Error("SettingsLauncherProvider is missing");
  return open;
}
